import * as React from 'react';
import { Options } from 'ui';
import styles from './category-tile-view.scss';
import { CodeSelectorTileViewProps, CodeSelectorTileView } from 'app/components';

import type { JSX } from "react";

interface CategoryTileViewProps extends CodeSelectorTileViewProps, Options<number> {
  /**
   * Make flex item take full width on a row
   */
  fullWidth?: boolean;
  leafNodeOnly?: boolean;
  extraFooterButton?: (onCloseCallback: (onClose: void) => void) => JSX.Element;
}

export const CategoryTileView: React.FC<React.PropsWithChildren<CategoryTileViewProps>> = (props) => {
  const { componentId, className, rowClassName, fullWidth, extraFooterButton } = props;

  return (
    <div id={componentId} className={`${className} ${styles.categoryTileView}`}>
      <CodeSelectorTileView 
        {...props} componentId={`${componentId}-sections`} 
        rowClassName={ rowClassName || fullWidth ? 'col-12' : 'col-12 col-lg-6'}
        extraFooterButton={extraFooterButton}
      />
    </div>
  );
};
